import { Helper } from "../../core/util/helper.js";
import { Assignment, Resource, SplittingDialogWrapperStaticData } from "./splittingDialogTypes.js";
import React from "react";


interface PreviewProps {
    originalAssignment: Assignment,
    assignments: Assignment[],
    staticData: SplittingDialogWrapperStaticData,
    hash: number
}

export class Preview extends React.Component<PreviewProps, any>{
    private root: HTMLDivElement;
    private treeRef: kendo.ui.TreeView;


    private mapToEventInfo = (assignment: Assignment) => {
        const result = assignment as EventInfo;
        result.IsContainer = Helper.isNullOrEmpty(assignment.ResNo);
        if (result.IsContainer) {
            result.ContainerName = this.props.staticData.containers.find(item => item.Value == assignment.GrNr).Name
        } else {
            result.Resource = this.props.staticData.resource;
        }
        return result;
    }

    private getDataSource = () => {
        const item: TreeItem = {
            expanded: true,
            id: this.props.originalAssignment.IsGuid,
            items: this.props.assignments.map((a) => {
                return {
                    expanded: true,
                    id: a.IsGuid,
                    items: [],
                    type: "child",
                    event: this.mapToEventInfo(a)
                }
            }),
            type: "parent",
            event: this.mapToEventInfo(this.props.originalAssignment)
        }
        return [item];
    }

    componentDidMount() {
        const parentTemplate = kendo.template(this.props.staticData.templates.parent);
        const childTemplate = kendo.template(this.props.staticData.templates.child);
        this.treeRef = $(this.root).kendoTreeView({
            dataSource: this.getDataSource(),
            template: (dataItem: { item: TreeItem }) => {
                const data = dataItem.item;
                if (data.type == "parent") {
                    return parentTemplate({ event: data.event, items: this.props.assignments.map(this.mapToEventInfo) })
                } else {
                    return childTemplate({ event: data.event })
                }
            }
        }).data("kendoTreeView")
    }

    componentDidUpdate(prevProps: PreviewProps) {
        if (prevProps.hash != this.props.hash) {
            this.treeRef.setDataSource(this.getDataSource() as any);
        }
    }

    render() {
        return <div style={{ height: "100%" }} ref={(ref) => { this.root = ref; }}></div>;
    }
}

interface TreeItem {
    id: string;
    expanded: boolean;
    items: TreeItem[];
    type: "parent" | "child";
    event?: EventInfo;
}

interface EventInfo extends Assignment {
    IsContainer: boolean;
    ContainerName: string;
    Resource: Resource;
}